import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  LIST_FETCHED,
  UPDATED,
  TOGGLE_LOADING,
  NOTIFY_FETCHED,
  NO_DO_FEEDBACK_NUM,
} from './actionTypes'
import { REPLY_REFRESH } from '../socket/actionTypes';

const initializeState = Map({
  entries: List(),
  fetching: false,
  total: 0,
  noDoFeedbackNum: 0,
  replyRefreshKey: 'initkey'
})

export default createReucer({
  [TOGGLE_LOADING]: (state) => state.update('fetching', fetching => !fetching),

  [LIST_FETCHED]: (state, { payload }) => {
    const { total, data } = payload
    return state
      .set('total', total)
      .set('entries', List(fromJS(data)))
  },
  [UPDATED]: (state, { payload }) =>
    state.update(
      'entries',
      list => {
        return list.filter((item) => (item && item.get("_id") !== payload.id))
      }
    ),
  [NOTIFY_FETCHED]: (state, { payload }) => {
    const { total } = payload
    return state.setIn(['notify', 'total'], total)
  },
  [NO_DO_FEEDBACK_NUM](state, { payload }) {
    return state.set('noDoFeedbackNum', payload?.total || 0)
  },
  [REPLY_REFRESH](state, { payload }) {
    return state.set('replyRefreshKey', Date.now())
  },
}, initializeState)
